export const DEFAULT_LOCATION_IMAGE =
  'https://cdn.kyruus.com/img/location-hero-default.jpg';

export const MEDIA_LABELS = {
  HERO: 'hero'
};

export const MEDIA_TYPES = {
  IMAGE: 'image'
};
